import { gql } from "@apollo/client";

export const addWebhookHeaderMutation = gql`
  mutation AddWebhookHeader ($id: ID!, $input: WebhookHeaderInput!) {
    addWebhookHeader (id: $id, input: $input) {
      id
      additional_headers
    }
  }
`;